import { Maybe } from '@Types'

export const getSourceNameBySourceId = (sourceId: Maybe<number>): string | null => {
    if (sourceId) {
        switch (sourceId) {
            case 724:
            case 725:
                return 'eSong'
            case 726:
                return 'The MLC'
            default:
                return 'CWR'
        }
    }
    return null
}
